import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Modal from 'react-modal';
import { BaseURL, uniqueToken } from '../../api/DataApis';
import request from '../../Apis/request';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';
import { QRCode } from 'qrcode.react';
import { Link } from 'react-router-dom';
import Loader from '../Chargers/Loader';
import ReactPaginate from 'react-paginate'; 
import Select from 'react-select';

const Evtor = () => {
  document.title = "Evtor || Evtor-Logs";
  const [OCPPData, setOCPPData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadings, setLoadings] = useState(false);
  const [ChargerData, setChargerData] = useState([]);
  const [selectedchargerEmi, setSelectedChargerEmi] = useState('');
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [transactionmodalIsOpen, settransactionModalIsOpen] = useState(false);
  const [RemoteStopModalIsOpen, setRemoteStopModalIsOpen] = useState(false);
  const [modalContent, setModalContent] = useState('');
  const [Message, setMessage] = useState([]);
  const [MessageType, setMessageType] = useState([]);
  const [connectorIDValue, setConnectorIDValue] = useState([]);
  const [IDtag, setIDTag] = useState('');
  const [transactionID, settransactionID] = useState('');
  const [selectedLimit, setSelectedLimit] = useState("");
  const [modalAamountContent, setModalAmountContent] = useState('');
  const [input1, setInput1] = useState('');
  const [input2, setInput2] = useState('');
  const [Users, setUsers] = useState([]);
  const [selectedUserID, setSelectedUserID] = useState('');
  const [selectedConnectorID, setSelectedConnectorID] = useState('');
  const [selectedchargerID, setSelectedChargerID] = useState('');
  const [selectedAmount, setSelectedAmount] = useState('');
  const [selectedUserMobile, setSelectedUserMobile] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [ToDate, setToDate] = useState("");
  const [applyFilters, setApplyFilters] = useState(false);
  const [connectorListing, setconnectorListing] = useState([]);
  const [ParentID, SetParentID] = useState('');
  const [totalCount, setTotalCount] = useState(null);
  const [Limit, setLimit] = useState();
  const [page, setPage] = useState(1); 
  const [pageCount, setPageCount] = useState(0); 
  const [walletAmount, setWalletAmount] = useState("");

  const UserOptons = Users?.map(user => ({
    value: user._id,
    label: `${user.name} (${user.mobile})`,
  mobile: user?.mobile,
  wallet_amount: user?.wallet_amount
  }));

  
    useEffect(() => {
      // Get today's date
      const today = new Date().toISOString().split("T")[0]; // Formats the date as "YYYY-MM-DD"
  
      // Set today's date as the default value for both fromDate and ToDate
      setFromDate(today);
      setToDate(today);
    }, []);

  

  const handleUserid = (selectedOption) => {
    if (selectedOption) {
      console.log("-----------------------", selectedOption?.wallet_amount)
      const { value: selectedUserID, mobile: selectedMobile, wallet_amount: walletAmount } = selectedOption;
  
      setSelectedUserID(selectedUserID); // Store the user ID
      setSelectedUserMobile(selectedMobile); // Store the mobile number
      setWalletAmount(walletAmount)
    // Store wallet amount
  
    
    } else {
      // Clear selections if no option is selected
      setSelectedUserID(null);
      setSelectedUserMobile(null);
  
    }
  };

  const handleResett = (event) => {
    event.preventDefault()
   navigate(`/evtor/evtorListing`);
    }


  const handlePageClick = (data) => {
    const selectedPage = data.selected + 1; // ReactPaginate uses zero-based index
    setPage(selectedPage); // Update the current page state
  };

  const chargerOptions = ChargerData?.map((item) => ({
    value: `${item?.imei_number}@${item?._id}`, // Value combines IMEI and ID
    label: item?.imei_number, // Display the IMEI number
  }));
  

  let navigate = useNavigate();
  const generateRandomNumber = () => {
    return Math.floor(10000000 + Math.random() * 90000000); // Generates a number between 10000 and 99999
  };

  const handlefromDate = (e) => {
    setFromDate(e.target.value);
  }
  const handleToDate = (e) => {
    setToDate(e.target.value);
  }
  const handleMessageTypeChange = (e) => {
  setMessageType(e.target.value);
  };
  const handleStop = async () => {
    if (!transactionID) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Please Enter Transaction ID.",
      });
      return false;
    }
    try {
      // Start the loading state with Swal
      Swal.fire({
        title: 'Processing...',
        text: 'Stopping charger, please wait...',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });
  
      // Make the API request
      const response = await fetch(`${BaseURL}/user/stop-evtor-charging`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${uniqueToken}`,
        },
        body: JSON.stringify({
          "charger_id": selectedchargerID,
          "transactionId" : transactionID
        }),
      });
  
      const data = await response.json(); // Parse the JSON response
  
      // Stop the loader
      fetchOcppData();
      Swal.close();
  
      // Check if the response indicates success
      if (response?.ok && data?.statusCode === 200) {
        Swal.fire({
          title: 'Success!',
          text: data.message,
          icon: 'success',
          confirmButtonText: 'OK',
        });
        fetchOcppData(); 
        closeStopTransaction();
      } else {
        Swal.fire({
          title: 'Error!',
          text: data.message || 'An error occurred while stopping the charger.',
          icon: 'error',
          confirmButtonText: 'OK',
        });
      }
    } catch (error) {
      // Stop the loader and handle the error
      Swal.close();
      console.error('Error:', error);
      Swal.fire({
        title: 'Error!',
        text: 'Something went wrong. Please try again later.',
        icon: 'error',
        confirmButtonText: 'OK',
      });
    }
  };
console.log("ChargerData", ChargerData);



const handleAmount = (e)=> {
  setSelectedAmount(e.target.value);
}
const handleConnectorID = (e)=> {
  const selectedConnectorID = e.target.value;
  const connectorId = e.target.selectedOptions[0].getAttribute('connectorId');
  
// value={user?._id}  
//onnectorID={user?.connectorId}
 
  // setConnectorIDValue(connectorId);
  SetParentID(selectedConnectorID);
}
//handleUserid, handleAmount, handleConnectorID
console.log("ParentrID",ParentID);
  const handleFetchingChange = () => {
    fetchOcppData();
  };
  const handleTransactionIDChange = (e) => {
    settransactionID(e.target.value);
  };

  const handleMessageChange = (e) => {
    
    setMessage(e.target.value);
  };

 
  const handleConnectorIDChange = (e) => {
    setConnectorIDValue(e.target.value);
  };

  const handleIDTagChange = (e) => {
    setIDTag(e.target.value);
  }

  const fetchChargers = async () => {
    setLoading(true);
    const apiEndpoint = `${BaseURL}/chargers/?master_charger_type=evtor-0`;

    try {
      const response = await axios.get(apiEndpoint, {
        headers: {
          "Content-type": "application/json; charset=UTF-8",
          Authorization: `Bearer ${uniqueToken}`,
        },
      });
      setChargerData(response.data.data.data || []);
    } catch (error) {
      console.error("Error fetching ChargerData:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchChargers();
  }, []);

 

  const fetchConnectors = async () => {
    setLoading(true);
    
    const apiUrl = `${BaseURL}/master/ac-0`;

    try {
        const response = await axios.get(apiUrl, {
            headers: {
                "Content-type": "application/json; charset=UTF-8",
                Authorization: `Bearer ${uniqueToken}`,
            },
        });
        console.log("response", response);
        setconnectorListing(response.data.data || []);
      
    } catch (error) {
        console.error("Error fetching users:", error);
    } finally {
        setLoading(false);
    }
  };

  useEffect(() => {
    fetchConnectors();
  }, []);

  
  
  const fetchOcppData = async (applyFilters = false, messagetype = null, FromDate = null, toDate = null, selectedlimit = null) => {
    setLoadings(true);
  
    const queryParams = [];

    // Add `chargerEmi` filter if selected
    if (selectedchargerEmi) {
        queryParams.push(`charger_emi=${selectedchargerEmi}`);

        // Include `messageType` if it's also selected when `chargerEmi` is selected
        const finalMessageType = messagetype || MessageType;
        if (finalMessageType) {
            queryParams.push(`request_3=${finalMessageType}`);
        }
    }

    // Apply additional filters if `applyFilters` is true
    if (applyFilters) {
        const finalMessageType = messagetype || MessageType;
        if (finalMessageType && !queryParams.includes(`request_3=${finalMessageType}`)) {
            queryParams.push(`request_3=${finalMessageType}`);
        }
    }

    // Ensure date filters are included if they are passed or already selected
    const finalFromDate = FromDate || fromDate; // Use passed `FromDate` or fallback to `fromDate` state
    const finalToDate = toDate || ToDate; // Use passed `toDate` or fallback to `ToDate` state
    const finalSelectedLimit = selectedlimit || selectedLimit; // Use passed `selectedlimit` or fallback to `selectedLimit` state

    // Get today's date in YYYY-MM-DD format
    const today = new Date().toISOString().split('T')[0]; 

    // If `FromDate` or `toDate` are not provided, fallback to today's date
    if (!finalFromDate) {
        queryParams.push(`from_date=${today} 00:00:00`);  // Default from date to today at 00:00:00
    } else {
        queryParams.push(`from_date=${finalFromDate} 00:00:00`);  // Use the passed or state `fromDate`
    }

    if (!finalToDate) {
        queryParams.push(`to_date=${today} 23:59:59`);  // Default to date to today at 23:59:59
    } else {
        queryParams.push(`to_date=${finalToDate} 23:59:59`);  // Use the passed or state `ToDate`
    }

    // Include `limit` filter if selected
    if (finalSelectedLimit) {
        queryParams.push(`limit=${finalSelectedLimit}`);
    }

    // Create the query string
    const queryString = queryParams.length > 0 ? `&${queryParams.join('&')}` : '';

    try {
        const apiEndpoint = `${BaseURL}/evtorLog/?page=${page}${queryString}`;
        const response = await axios.get(apiEndpoint, {
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                Authorization: `Bearer ${uniqueToken}`,
            },
        });

        console.log('Fetched data:', response.data);

        if (response?.data?.status === 200) {
            setOCPPData(response.data.data || []);
            setTotalCount(response?.data?.totalCount);
            setPageCount(Math.ceil(response.data.totalCount / response.data.limit || 0));
            setLimit(response?.data?.limit || 0);
        }
        setLoadings(false);
    } catch (error) {
        console.error("Error fetching OCPP data:", error);
    } finally {
        setLoadings(false);
    }
};



  
  // Handle filter button click (Case 3)
  const handleFilterClick = () => {
    setPage(1);
    // Trigger fetch with `applyFilters` set to true and pass the MessageType, fromDate, and ToDate
    if (MessageType || fromDate || ToDate || selectedLimit) {
      fetchOcppData(true, MessageType, fromDate, ToDate, selectedLimit );
    } else {
    fetchOcppData(); 
    }
  };
  
  // Case 1 & 2: Initial load and when chargerEmi changes
  useEffect(() => {
    fetchOcppData(page);
  }, [selectedchargerEmi, page]); // Trigger whenever `selectedchargerEmi` changes
  
  const openModal = (content) => {
    setModalContent(content);
    setModalIsOpen(true);
  };
  console.log("modalcontent", modalContent);
  const closeModal = () => {
    setModalIsOpen(false);
    setModalContent('');
  };

  const openAmountModal = () => settransactionModalIsOpen(true);
  const openStopTransaction = () => setRemoteStopModalIsOpen(true);
  const closeStopTransaction = () => setRemoteStopModalIsOpen(false);

  // Function to handle closing the modal
  const closeAmountModal = () => settransactionModalIsOpen(false);

  // Function to handle form submission
  const handleSubmition = () => {
    console.log('Input 1:', input1);
    console.log('Input 2:', input2);
    // Perform any other action on form submission
    closeAmountModal();
  };

  const handleAmountSubmit = async (e) => {
    if (!selectedUserID) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Please select user first",
        allowOutsideClick: false,
        timer: 1500,
      });
      return false;
    }
    
    e.preventDefault(); // Prevent default form submission
    
    if (!selectedchargerEmi) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Please select a charger.",
      });
      return false;
    }
  
    if (!ParentID) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Please select a connector.",
      });
      return false;
    }
  
    const url = `${BaseURL}/user/required-payment/${selectedUserID}`;
    
    try {
      Swal.fire({
        title: 'Request in Process...',
        text: 'Please wait',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });
  
      const response = await axios.post(
        url,
        {
          "charger_id": selectedchargerID,
          "amount": selectedAmount,
          "master_connector_id": ParentID,
        },
        {
          headers: {
            "Content-Type": "Application/json",
            Authorization: `Bearer ${uniqueToken}`,
          }
        }
      );
  
      Swal.close();
  
      if (response.data.statusCode === 200) {
        closeAmountModal();
        Swal.fire({
          icon: "success",
          title: "Success",
          text: response.data.message,
          allowOutsideClick: false,
          timer: 1500,
        });
        // Clear the states after success
        SetParentID('');
        setSelectedAmount('');
        fetchOcppData();
      }
      
      else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: response.data.message,
          allowOutsideClick: false,
          timer: 1500,
        });
        closeAmountModal();
      }
  
    } catch (error) {
      Swal.close();
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error?.response?.data?.message || "An error occurred. Please try again.",
        allowOutsideClick: false,
        timer: 1500,
      });
      console.error("Request Failed:", error?.response?.data?.message);
    }
  };
  
  const handleExport = async () => {
    // If either `selectedchargerEmi` or `selectedLimit` is selected, proceed
    if (selectedchargerEmi || selectedLimit) {
      let apiUrll = `${BaseURL}/evtorLog/download-excel?`;
  
      // Case 1: Append `selectedchargerEmi` if it is selected
      if (selectedchargerEmi) {
        apiUrll += `charger_emi=${selectedchargerEmi}&`;
      }
  
      // Case 2: Append `selectedLimit` if it is selected
      if (selectedLimit) {
        apiUrll += `limit=${selectedLimit}&`;
      }
  
      // Append date filters if they exist
      if (fromDate) {
        apiUrll += `from_date=${fromDate.toString()}&`;
      }
  
      if (ToDate) {
        apiUrll += `to_date=${ToDate.toString()}&`;
      }
  
      // Remove the trailing "&" if it exists
      apiUrll = apiUrll.endsWith("&") ? apiUrll.slice(0, -1) : apiUrll;
  
      try {
        const response = await fetch(apiUrll, {
          headers: {
            Authorization: `Bearer ${uniqueToken}`,
          },
        });
  
        if (response.ok) {
          const blob = await response.blob();
          const url = window.URL.createObjectURL(new Blob([blob]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            `data_${selectedLimit ? `limit_${selectedLimit}` : `emi_${selectedchargerEmi}`}.xlsx`
          );
          document.body.appendChild(link);
          link.click();
          link.parentNode.removeChild(link);
        } else {
          alert("Failed to export data. Please try again.");
        }
      } catch (error) {
        console.error("Error exporting data:", error);
        alert("An error occurred while exporting data.");
      }
    } else {
      // Case 3: Neither `selectedchargerEmi` nor `selectedLimit` is selected
      alert("Please select a limit or charger EMI before exporting.");
    }
  };
  
  

  const fetchUsers = async () => {
    setLoading(true);
    
    const apiUrl = `${BaseURL}/user/get-all`;

    try {
        const response = await axios.get(apiUrl, {
            headers: {
                "Content-type": "application/json; charset=UTF-8",
                Authorization: `Bearer ${uniqueToken}`,
            },
        });
        console.log("response", response);
        setUsers(response.data.data || []);
      
    } catch (error) {
        console.error("Error fetching users:", error);
    } finally {
        setLoading(false);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

const handleRefetch = () => {
  fetchOcppData();
}
const handleChargerEmiChange = (selectedOption) => {
  if (selectedOption) {
    setPage(1);
    const [imei, id] = selectedOption.value.split("@");
    console.log("Selected IMEI and ID:", imei, id);
    setSelectedChargerEmi(imei);
    setSelectedChargerID(id);
  } else {
    setSelectedChargerEmi(null);
    setSelectedChargerID(null);
  }
};

 console.log("OCPPData", OCPPData);
 console.log("connectorID", ParentID);
 console.log("totalcount", totalCount);
 console.log("pagecountttttttt", pageCount);
 console.log("Limit", Limit);

  return (
    <div className='container-fluid' style={{ minHeight: '100vh', padding: '0px', margin: '0px' }}>
      <div className='row' style={{ height: '100%' }}>
        <div className='col-sm-12'>
          <div className='card'>
            <div className="portlet-body mx-3">
              <div className="d-flex justify-content-between align-items-center">
                <h4>Evtor Logs({totalCount ?  totalCount : "Loading.."})</h4>


              </div>
              <div className="card-header pb-0">
  <div className="d-flex justify-content-between mb-2"> {/* Changed justify-content */}
    <div className="button-group d-flex gap-2" style={{ top: "20px" }}>
      <div style={{ display: "inline-flex", alignItems: "center" , marginRight: '10px' }}>
      <Select
  options={chargerOptions} // Pass the options array
  onChange={handleChargerEmiChange} // Handle selection
  placeholder="Select Charger"
  isClearable // Allow clearing the selection
  
  styles={{
    control: (base) => ({
      ...base,
      height: '34px',
      width: '250px',
      marginRight: '10px',
    }),
  }}
/>

  <input
  type="text"
  className="form-control select2 select2-offscreen"
  value={fromDate}
  onFocus={(e) => (e.target.type = "date")}
  onBlur={(e) => (e.target.type = e.target.value ? "date" : "text")}
  placeholder="From Date"
  onChange={handlefromDate}
  style={{ height: '34px', marginRight: '10px' }} // Adjusted for consistency
/>

<input
  type="text"
  value={ToDate}
  className="form-control select2 select2-offscreen"
  onFocus={(e) => (e.target.type = "date")}
  onBlur={(e) => (e.target.type = e.target.value ? "date" : "text")}
  placeholder="To Date"
  onChange={handleToDate}
  style={{ height: '34px', marginRight: '10px' }} // Adjusted for consistency
/>


        <input
          type="button"
          className="btn btn-success"
          style={{ marginRight: '10px', height: '34px' }} // Adjusted height for consistency
          value="Filter"
          onClick={handleFilterClick}
        />
          <button
          type="button"
          className="btn btn-success"
          style={{ marginRight: '10px', height: '34px' }} // Adjusted height for consistency
          
          onClick={handleResett}
        >Reset
          </button>

        <select
        className="form-control"
          value={selectedLimit}
          onChange={(e) => setSelectedLimit(e.target.value)}
          style={{
            height: "34px", // Adjusted height for consistency
            // border: "1px solid black",
            // borderRadius: "27%",
            // marginRight: "10px",
          }}
        >
          <option value="">Select Limit</option>
          <option value="5">5</option>
          <option value="10">10</option>
          <option value="20">20</option>
          <option value="50">50</option>
          <option value="100">100</option>
          <option value="1000">1000</option>
          <option value="2000">2000</option>
        </select>
       <button
  className="drop-marg12 btn btn-success"
  style={{
    height: "34px", // Maintain height
    width: "100px", // Increased width for better appearance
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginLeft: "10px",
    padding: "0 10px", // Added horizontal padding for more space around text
    fontWeight: "bold", // Make the font bold
    fontSize: "14px", // Adjust font size if necessary
    letterSpacing: "0.5px", // Add letter spacing
    cursor: "pointer", // Change cursor to pointer on hover
    transition: "background 0.3s, transform 0.2s", // Smooth transition effects
  }}
  onClick={handleExport}
  onMouseEnter={(e) => {
    e.target.style.backgroundColor = "#218838"; // Darker shade on hover
    e.target.style.transform = "scale(1.05)"; // Slightly enlarge on hover
  }}
  onMouseLeave={(e) => {
    e.target.style.backgroundColor = ""; // Reset to Bootstrap's default success color
    e.target.style.transform = "scale(1)"; // Reset scale
  }}
>
  Export
</button>
</div>
    </div>
  </div>
  <hr style={{ marginTop: "0px" }} />
</div>
<div className="row" style={{ display: 'flex', alignItems: 'flex-start' }}>
                {selectedchargerEmi && (
                  <div className="col-md-3">
                    <div className="commands-container p-3" style={{
                      borderRadius: "5px",
                      width: '100%',
                      display: 'flex',
                      flexDirection: 'column',
                      flexShrink: 0,
                      border: '1px solid #000000'
                    }}>
                      <h5 className="text-white">Commands</h5>
                     
                      <button className="btn btn-primary btn-block mb-2" style={{ padding: '20px', lineHeight: '1.5' }}  onClick={openAmountModal}>
                        REMOTE START <br />
                      </button>
                      <button className="btn btn-primary btn-block mb-2" style={{ padding: '20px', lineHeight: '1.5' }} onClick={openStopTransaction} >
                        REMOTE STOP<br /> TRANSACTION
                      </button>
                      {/* <button className="btn btn-primary btn-block mb-2" onClick={() => openModal('ChangeAvailability')}>
                        RESET
                      </button> */}
                    </div>
                  </div>
                )}

                <div className={selectedchargerEmi ? "col-md-9" : "col-md-12"}>
                <div className="card-body" style={{ paddingTop: 0 }}>
  {loadings ? (
    <Loader />
  ) : (
    <>
    <div className="table-responsive" style={{ marginTop: '10px' }}>
      {totalCount === 0 ? ( // Only show "No Data Found" when there's no data and loading is done
         <>
         <h5>No Data Found</h5>
         </> 
      ) : (
                 
        <table className="display dataTable" id="advance-1">
        <thead>
          <tr>
           <th>Sr. No</th>
           <th>Charger EMI</th>
           <th>Request</th>
            <th>Response</th>
            <th>Created Date</th>
      
          </tr>
        </thead>
        <tbody>
          {OCPPData?.length === 0 ? (
            <tr>
           <h6>No Data Found...</h6>
            </tr>
          ) : (
            OCPPData?.map((ocpp, index) => (
              <tr key={index}>
                
                <td>{(page - 1) * Limit + index + 1}</td>
                <td>{ocpp?.charger_emi}</td>
                  <td>
                    <pre>{JSON.stringify(ocpp.request, null, 2)}</pre>
                  </td>
                  <td>
                    <pre>{JSON.stringify(ocpp.response, null, 2)}</pre>
                  </td>
                  <td>{ocpp?.createdAt}</td>

              </tr>
            ))
          )}
        </tbody>
      </table>
      )}

    </div>
    <div className="pagination-container mt-4">

<ReactPaginate
  previousLabel={'Previous'}
  nextLabel={'Next'}
  breakLabel={'...'}
  pageCount={pageCount}
  marginPagesDisplayed={2}
  pageRangeDisplayed={5}
  onPageChange={handlePageClick}
  containerClassName={'pagination'}
  subContainerClassName={'pages pagination'}
  activeClassName={'active'}
  forcePage={page - 1} 
/>
</div>
    </>
  )}
</div>


                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Modal */}
    

      <Modal
          isOpen={transactionmodalIsOpen}
          onRequestClose={closeAmountModal}
          contentLabel="Perform Action Modal"
          style={{
            content: {
              top: '50%',
              left: '50%',
              right: 'auto',
              bottom: 'auto',
              marginRight: '-50%',
              transform: 'translate(-50%, -50%)',
            },
          }}
        >
          <h2>
    Enter Details
    {selectedUserID && ` (Wallet Amount: ${walletAmount})`}
</h2>
          <form>
  <div className="form-group" style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
    <label htmlFor="input2" style={{ marginRight: '10px', width: '150px' }}>Select User</label>
    <Select
            value={UserOptons.find((option) => option.value === selectedUserID) || null}
            onChange={handleUserid}
            options={UserOptons}
            placeholder="Select User"
            isClearable
            styles={{
              control: (base) => ({
                ...base,
                height: '38px',
               // Make width responsive
                boxShadow: 'none',
                minWidth: '300px', // Set minimum width
                maxWidth: '300px',
                // minWidth: '200px', // Ensures it can shrink below 150px if needed
                flex: 1, // Allow select to grow and shrink
              }),
            }}
          />

  </div>

  <div className="form-group" style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
    <label htmlFor="input1" style={{ marginRight: '10px', width: '150px' }}>Connector ID</label>
    <select 
      type="text"
      className="form-control"
      id="input1"
      onChange={handleConnectorID}
      placeholder="Enter Connector ID"
      style={{ flex: 1,  minWidth: '300px', // Set minimum width
        maxWidth: '300px', }} // Takes up the remaining space
    >
      <option>Select Option</option>
      {connectorListing?.map((user) => (
    <option 
      key={user?._id} 
      value={user?._id}  
      // connectorID={user?.connectorId}
    
    >
      {user?.title}
    </option>
  ))}
      
    </select>
  </div>

  <div className="form-group" style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
    <label htmlFor="input2" style={{ marginRight: '10px', width: '150px' }}>Request Amount</label>
    <input
      type="text"
      className="form-control"
      id="input2"
      onChange={handleAmount}
      placeholder="Enter requested Amount"
      style={{ flex: 1,  minWidth: '300px', // Set minimum width
        maxWidth: '300px', }} // Takes up the remaining space
    />
  </div>

  <div className="form-group">
    <button type="button" className="btn btn-primary" onClick={handleAmountSubmit} style={{ marginRight: '10px' }}>
      Request for Charging
    </button>
    <button type="button" className="btn btn-secondary" onClick={closeAmountModal}>
      Close
    </button>
  </div>
</form>

        </Modal>


        <Modal
          isOpen={RemoteStopModalIsOpen}
          onRequestClose={closeStopTransaction}
          contentLabel="Perform Action Modal"
          style={{
            content: {
              top: '50%',
              left: '50%',
              right: 'auto',
              bottom: 'auto',
              marginRight: '-50%',
              transform: 'translate(-50%, -50%)',
            },
          }}
        >
          <h2>Enter Details</h2>
          <form>



  <div className="form-group" style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
    <label htmlFor="input2" style={{ marginRight: '10px', width: '150px' }}>Transaction ID</label>
    <input
      type="intiger"
      className="form-control"
      id="input2"
      onChange={handleTransactionIDChange}
      placeholder="Enter Transaction ID"
      style={{ flex: 1 }} // Takes up the remaining space
    />
  </div>

  <div className="form-group">
    <button type="button" className="btn btn-primary" onClick={handleStop} style={{ marginRight: '10px' }}>
      Stop
    </button>
    <button type="button" className="btn btn-secondary" onClick={closeStopTransaction}>
      Close
    </button>
  </div>
</form>

        </Modal>
    </div>
  );
};

export default Evtor;